import MainContent from '../../components/mainContent/MainContent';
import { ConexionesContent } from './components/ConexionesContent';

export default function AdminConexiones() {

    return (
        <>
            <MainContent
                component={<ConexionesContent />}
                titulo={'Conexiones'}
                noBackground
                tableMaxWidth
            />
        </>
    );
};
